import React from 'react';
import { PassoExecutado } from '@/models/PassoExecutado';
import fhirpath from 'fhirpath';
import { ArtifactFormOverrides } from '@/features/artifacts/components/ArtifactForm/ArtifactForm.types';
import { useArtifactFormConfig } from '@/features/artifacts/hooks/useArtifactFormConfig';
import { Paragraph } from '@/features/artifacts/components/ArtifactForm/ArtifactField.widgets';
import CardSolicitacao, {
  CardSolicitacaoProxyProps,
} from '../../CardSolicitacao';
import SolicitacaoList from '..';
// import { Container } from './styles';

const Form: ArtifactFormOverrides = [
  {
    name: 'reasonCode',
    label: 'Indicação Clínica',
    attrs: { autoFocus: true },
    required: true,
    containerStyle: { flex: '0 1 100%' },
  },
  {
    name: 'note',
    label: 'Observações',
    containerStyle: { flex: '0 1 100%' },
    widget: Paragraph,
  },
];

const CardExame: React.FC<CardSolicitacaoProxyProps> = ({
  solicitacao,
  ...rest
}) => {
  const form = useArtifactFormConfig('solicitacao-exame', Form);

  const title = React.useMemo(() => {
    return (
      fhirpath.evaluate(
        solicitacao.pedido,
        'code.select(text | coding.display).first()',
      )[0] || 'Exame '
    );
  }, [solicitacao.pedido]);

  const description = React.useMemo(() => {
    const reason = fhirpath.evaluate(
      solicitacao.pedido,
      'ServiceRequest.reasonCode.select(text | coding.display).first()',
    );
    if (reason.length) {
      return reason[0];
    }

    return '';
  }, [solicitacao.pedido]);

  return (
    <CardSolicitacao
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      title={title}
      description={description}
      solicitacao={solicitacao}
      form={form}
    />
  );
};

interface Props {
  passo: PassoExecutado;
}
const SolicitacaoListExame: React.FC<Props> = ({ passo }) => {
  return (
    <SolicitacaoList
      passo={passo}
      tipo="solicitacao-exame"
      CardSolicitacaoComponent={CardExame}
      groupTitle="Selecione os exames que você quer solicitar no seu prontuário."
      addConfig={{
        title: 'Adicionar exame complementar',
      }}
    />
  );
};

export default SolicitacaoListExame;
